import { render, staticRenderFns } from "./LpTop.vue?vue&type=template&id=1c56fb1d&"
import script from "./LpTop.vue?vue&type=script&lang=js&"
export * from "./LpTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports